import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, ArrowRight } from 'lucide-react';
import Hero from '../components/Hero';
import ContactSection from '../components/ContactSection';
import TripSection from '../components/TripSection';
import Partners from '../components/Partners';
import Testimonials from '../components/Testimonials';
import BookingForm from '../components/BookingForm';
const Home = () => {
  return <div className="w-full" data-id="element-891">
      <Hero data-id="element-892" />
      <ContactSection data-id="element-893" />
      <TripSection data-id="element-894" />
      <Partners data-id="element-895" />
      <Testimonials data-id="element-896" />
      <BookingForm data-id="element-897" />
    </div>;
};
export default Home;